import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';

enum ContractDocumentEnum {
    getAllAvailableSignaturesTypes = '/signatures/types',
    get = '/',
    edit = '/',
    create = '/',
    delete = '/'
}

export default class ContractDocumentService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, '/contracts');
    }

    public getAllSignatureTypes = async () => this.GET(ContractDocumentEnum.getAllAvailableSignaturesTypes);
    public getAll = async () => await this.GET(ContractDocumentEnum.get);
    public getById = async (batchId: number) =>
        await this.GET(`${ContractDocumentEnum.get}${batchId}`);
    public create = async data =>
        await this.POST(ContractDocumentEnum.create, data);
    public delete = async data =>
        await this.DELETE(ContractDocumentEnum.delete, data);
}



// WEBPACK FOOTER //
// ./src/services/api/ContractDocument.service.ts